import type {
  DeleteCheckResponse,
  FinancialFieldDefinition,
  FinancialSituationModel,
  FinancialSituationModelParsed,
  FinancialSituationModelSettings,
  FinancialSituationStatusDef,
} from "@repo/shared/types";
import { del, get, patch, post } from "@/lib/api/_client";

const BASE = "/internal/financial-situation-models";

// --- Models ---

export function list(): Promise<FinancialSituationModel[]> {
  return get(BASE);
}

export function getById(id: string): Promise<FinancialSituationModelParsed> {
  return get(`${BASE}/${id}`);
}

export function create(data: {
  name: string;
  description?: string;
  language?: string;
}): Promise<FinancialSituationModel> {
  return post(BASE, data);
}

export function update(
  id: string,
  data: {
    name?: string;
    description?: string;
    incomeFields?: FinancialFieldDefinition[];
    assetFields?: FinancialFieldDefinition[];
    liabilityFields?: FinancialFieldDefinition[];
    commitmentFields?: FinancialFieldDefinition[];
    statuses?: FinancialSituationStatusDef[];
    settings?: FinancialSituationModelSettings;
    currency?: string;
  },
): Promise<{ success: boolean }> {
  return patch(`${BASE}/${id}`, data);
}

export function checkDelete(id: string): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${id}/delete-check`);
}

export function remove(id: string): Promise<{ success: boolean }> {
  return del(`${BASE}/${id}`);
}
